module.exports = __webpack_public_path__ + "img/wireframe-cube.8785573b.png";